import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { AddonsPage } from '@/features/service-agreement-addons/addons-page';

/**
 * The service-agreement add-ons. The `addons` feature's endpoints require `pricing:read` to list
 * and `pricing:write` to change. The tyre add-ons (`/addons`) are the same page on the other flow.
 */
export const Route = createFileRoute('/_app/service-agreement/addons')({
  staticData: { featureKey: 'addons' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, { feature: 'addons', permissions: ['pricing:read'] }),
  component: ServiceAgreementAddons,
});

function ServiceAgreementAddons() {
  return <AddonsPage flow="SERVICE_AGREEMENT" />;
}
